<div class="row smedashboard">
  <div class="col-md-12 smeblock">
    <div class="col-md-2 smeleftpanel srScrollbar" id="style-4" style="height: 785px; cursor: pointer">
      <p style="color: #fff;">Welcome to AQUATOQ !</p>
      <div class="row loginDetails">
        <div class="col-xs-3">
          <img src="../../../assets/image/smeimages/Profile Image.png" height="40" width="40"/></div>
        <div class="col-xs-9">
          <p>{{loginPersonType}}</p>
          <p>{{loginUserName}}</p>
        </div>
      </div>
      <div class="row locationScroll">
        <div class="row">
          <form class="form-inline">
            <input (keyup)="searchBusiness()" [(ngModel)]="search" name="search" autocomplete="off"
                   class="locationSearch" placeholder="Search Farm.." type="text">
          </form>
        </div>
        <p style="color: #fff">Farms</p>
        <div class="row searchfun" [ngClass]="i==selectedCardSites?'select-site-card':'unselect-site-card'"
             (click)="siteChange(farms['farmSite']['id'], i)"
             *ngFor="let farms of farmSites; let i = index">
          <div class="col-xs-12" style="padding: 0px">
            <div class="col-xs-10" style="padding: 0px" (click)="getPondsByFarmsiteID(farms['farmSite']['id'])">
              <!--<div class="col-xs-9">-->
              <p>{{farms['farmSite']['businessID']['businessName'] + " #" + farms['farmSite']['address']['village']}} </p>
              <p *ngIf="farms['messages'] && farms['messages'].length>0">{{(farms['messages'][0]['date'])}}</p>
              <span
                *ngIf="farms['messages']&&farms['messages'].length>0">{{farms['messages'][0]['message']['MIMEType'] == '.txt' ? farms['messages'][0]['message']['data'] : 'attachment'}} </span>
            </div>
            <div class="col-xs-2">
              <span class="message-count-span" *ngIf="farms['unreadCount']>0">
                                         <span class="message-count">{{farms['unreadCount']}}</span>
                                     </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-5 middlediv" style="padding: 0px; border-left: 1px solid #fff;">
      <div class="row middle_heading">
        <div class="col-md-12 middleblock_data">
          <div class="col-md-9">
            <span>{{selectedBusinessName}}</span> <span> #-{{selectedLocationName}}</span>
          </div>
          <div class="col-md-3">
            <span class="temparature">{{temperature}}</span>
            <span><img src="../../../assets/image/smeimages/Weather.png" height="42" width="47"/></span>
          </div>
        </div>
      </div>
      <div class="pondsData">
        <div id="carousel-example-one" class="carousel slide" data-interval="false">
          <!-- Wrapper for slides -->
          <div class="carousel-inner" role="listbox">
            <p *ngIf="recordsList && recordsList.length == 0"
               style="font-size: 20px; font-weight: 100; text-align: center">No Data</p>
            <div class="item" [ngClass]="{'active':i==0 }"
                 *ngFor="let recs of recordsList; let i = index">
              <span class="col-md-2"
                    [ngClass]="(j==selectedCardPos&&selectectedPondPage == pondsPage)?'select-pond-card':'unselect-pond-card'"
                    *ngFor="let item of recs; let j = index" (click)="pondChange(item.id, j)">
                {{item.name}}
              </span>
            </div>
          </div>

          <!-- Controls -->
          <a class="left carousel-control preIcon" href="#carousel-example-one" role="button" data-slide="prev"
             (click)="previousPondsPage()" *ngIf="recordsList && recordsList.length > 0">
            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="right carousel-control nextIcon" href="#carousel-example-one" role="button" data-slide="next"
             (click)="nextPondsPage()" *ngIf="recordsList && recordsList.length > 0">
            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
        <!--imageslist block-->
        <div class="row" *ngIf="imageDetails && imageDetails.length>0">
          <div id="myCarousel" class="carousel slide" data-ride="carousel" style="margin-top: 50px;">
            <!-- Indicators -->
            <ol class="carousel-indicators">
              <li data-target="#myCarousel" [ngClass]="i==0?'active':''" [attr.data-slide-to]="i"
                  *ngFor="let image of imageDetails;let i = index"></li>
            </ol>

            <!-- Wrapper for slides -->
            <div class="carousel-inner">
              <div class="item" [ngClass]="i==0?'active':''" *ngFor="let image of imageDetails;let i = index">
                <p class="imagesDate">{{image.date}}</p>
                <img *ngIf="image['fileType'] == 'image'"
                     [src]="image['image_url']" alt="Los Angeles" style="width:100%; height: 340px;">
                <video width="100%" height="340" controls *ngIf="image['fileType'] == 'video'">
                  <source [src]="image['image_url']" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
                <img *ngIf="image['fileType'] == 'invalidfile'"
                    [src]="" alt="" style="width:100%; height: 340px;">
                <p style="text-align: center;">{{image.description}}</p>
              </div>
            </div>

            <!-- Lef t and right controls -->
            <a class="left carousel-control cursol-custom-control" href="#myCarousel" data-slide="prev">
              <span class="glyphicon glyphicon-chevron-left"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="right carousel-control cursol-custom-control" href="#myCarousel" data-slide="next">
              <span class="glyphicon glyphicon-chevron-right"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
        <hr style="margin-top: 30px;">
        <div class="row" style="padding: 0px 15px;"
             *ngIf="(readings && readings.length > 0) && (activePondsList.length > 0)">
          <div class="row waterReadings" *ngFor="let readings of readings">
            <div class="pondName">
              <span class="noWaterData">{{pondName}}</span>
            </div>
            <div>
              <p style="text-align: right;">{{readings.time}}</p>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="waterImage">
                <p><img src="../../../assets/image/smeimages/Water.png" height="40" width="50"/></p>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="content colour-1">
                <p class="waterlabel">PH</p>
                <hr>
                <p class="watervalues">{{readings && readings.pH}}</p>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="content colour-1">
                <p class="waterlabel">DO</p>
                <hr>
                <p class="watervalues">{{(readings && readings.do2 == null) ? 'NA' : readings && readings.do2}}</p>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="content colour-1">
                <p class="waterlabel">Temp</p>
                <hr>
                <p
                  class="watervalues">{{readings && readings.temperature == null ? 'NA' : readings && readings.temperature}}</p>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="content colour-1">
                <p class="waterlabel">TAN</p>
                <hr>
                <p
                  class="watervalues">{{(readings && readings.tan == null || readings && readings.tan == -1) ? 'NA' : readings && readings.tan}}</p>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="watermore_icon" data-toggle="modal" data-target="#myModal"
                   (click)="getViewMoreWaterReading()">
                <img src="../../../assets/image/smeimages/Three_Dots.png" height="39" width="11"/>
              </div>
            </div>
          </div>
        </div>
        <!--smpling-->
        <div class="row metricscolor" *ngIf="feedlog">
          <div class="row Sampling">
            <div class="row">
              <p style="text-align: right;">{{feedlog.samplingDate | date:"dd-MMM-yyyy"}}</p>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="waterImage">
                <p><img src="../../../assets/image/smeimages/ABW.png" height="40" width="53"/></p>
              </div>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12">
              <div class="content colour-1">
                <p class="waterlabel">ABW</p>
                <hr>
                <p
                  class="watervalues">{{feedlog && feedlog.abw == null ? 'NA' : feedlog && feedlog.abw}}
                  gm</p>
              </div>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12">
              <div class="content colour-1">
                <p class="waterlabel">ADG</p>
                <hr>
                <p
                  class="watervalues">{{feedlog && feedlog.adgValue == null ? 'NA' : feedlog && feedlog.adgValue}}
                  Gms</p>
              </div>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12">
              <div class="content colour-1">
                <p class="waterlabel">Weight gained</p>
                <hr>
                <p
                  class="watervalues">{{feedlog && feedlog.weigthGained == null ? 'NA' : feedlog && feedlog.weigthGained}}</p>
              </div>
            </div>
            <div class="col-md-1 col-sm-4 col-xs-12">
              <div class="more_icon" data-toggle="modal" data-target="#samplingmyModal"
                   (click)="viewMoreSampling()">
                <img src="../../../assets/image/smeimages/Three_Dots.png" height="39" width="11"/>
              </div>
            </div>
          </div>
          <!--feed-->
          <div class="row Sampling">
            <div class="row">
              <p style="text-align: right;">{{feedlog.daysFeedDate | date:"dd-MMM-yyyy"}}</p>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="waterImage">
                <p><img src="../../../assets/image/smeimages/Feed.png" height="41" width="45"/></p>
              </div>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12">
              <div class="content colour-1">
                <p class="waterlabel">FCR</p>
                <hr>
                <p
                  class="watervalues">{{(feedlog && feedlog.FCR == null) ? 'NA' : (feedlog && feedlog.FCR).toFixed(2)}}</p>
              </div>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12">
              <div class="content colour-1">
                <p class="waterlabel">Day's Feed</p>
                <hr>
                <p
                  class="watervalues">{{feedlog && feedlog.daysFeed == null ? 'NA' : (feedlog && feedlog.daysFeed / 1000).toFixed(2)}}
                  Kgs</p>
              </div>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12">
              <div class="content colour-1">
                <p class="waterlabel">Total Feed</p>
                <hr>
                <p
                  class="watervalues">{{feedlog && feedlog.totalConsumption == null ? 'NA' : (feedlog && feedlog.totalConsumption / 1000).toFixed(2)}}
                  Kgs</p>
              </div>
            </div>
            <div class="col-md-1 col-sm-4 col-xs-12">
              <div class="more_icon" data-toggle="modal" data-target="#feedmyModal" (click)="viewMoreFeed()">
                <img src="../../../assets/image/smeimages/Three_Dots.png" height="39" width="11"/>
              </div>
            </div>
          </div>
          <!--ffff-->
          <div class="row Sampling">
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="waterImage">
                <p><img src="../../../assets/image/smeimages/BioMass.png" height="41" width="41"/></p>
              </div>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12">
              <div class="content colour-1">
                <p class="waterlabel">Biomass</p>
                <hr>
                <p
                  class="watervalues">{{feedlog && feedlog.totalBiomass == null ? 'NA' : (feedlog && feedlog.totalBiomass / 1000).toFixed(2)}}
                  Kgs</p>
              </div>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12">
              <div class="content colour-1">
                <p class="waterlabel"># of animals</p>
                <hr>
                <p
                  class="watervalues">{{feedlog && feedlog.numberOfAnimals == null ? 'NA' : feedlog && feedlog.numberOfAnimals}}</p>
              </div>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12">
              <div class="content colour-1">
                <p class="waterlabel">Survival</p>
                <hr>
                <p
                  class="watervalues">{{(feedlog && feedlog.survivalRate == null) ? 'NA' : (feedlog && feedlog.survivalRate)}}
                  %</p>
              </div>
            </div>
            <!--<div class="col-md-1 col-sm-4 col-xs-12">
              <div class="more_icon" data-toggle="modal" data-target="#feedmyModal" (click)="viewMoreFeed()">
                <img src="../../../assets/image/smeimages/Three_Dots.png" height="39" width="11"/>
              </div>
            </div>-->
          </div>
        </div>
      </div>
      <!--water modal popup-->
      <div class="modal fade" id="myModal" role="dialog" *ngIf="moreReadings && moreReadings.length>0">
        <div class="modal-dialog modal-lg">

          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <span class="farmer">{{pondName}}&nbsp;Readings</span>
            </div>
            <div class="modal-body">
              <div class="panel-body table-responsive">
                <table class="table table-striped table-bordered table-hover">
                  <thead>
                  <tr>
                    <th>Date(Time)</th>
                    <th *ngIf="readingsCondtions.pH">pH</th>
                    <th *ngIf="readingsCondtions.salinity">Salinity</th>
                    <th *ngIf="readingsCondtions.do2">DO</th>
                    <th *ngIf="readingsCondtions.turbidity">Turbidity</th>
                    <th *ngIf="readingsCondtions.conductivity">Conductivity</th>
                    <th *ngIf="readingsCondtions.tds">TDS</th>
                    <th *ngIf="readingsCondtions.temperature">Temperature</th>
                    <th *ngIf="readingsCondtions.sg">Specific Gravity</th>
                    <th *ngIf="readingsCondtions.nitrite">Nitrite</th>
                    <th *ngIf="readingsCondtions.calcium">Calcium</th>
                    <th *ngIf="readingsCondtions.magnesium">Magnesium</th>
                    <th *ngIf="readingsCondtions.alkalinity">Alkalinity</th>
                    <th *ngIf="readingsCondtions.hardness">Hardness</th>
                    <th *ngIf="readingsCondtions.carbonate">Carbonate</th>
                    <th *ngIf="readingsCondtions.bicarbonate">Bio carbonate</th>
                    <th *ngIf="readingsCondtions.tan">TAN</th>
                    <th *ngIf="readingsCondtions.uam">UAM</th>
                    <th *ngIf="readingsCondtions.ta">TA</th>
                    <th *ngIf="readingsCondtions.comment">Comment</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    *ngFor="let readings of moreReadings |  paginate: { itemsPerPage: noofitemsPerPage, currentPage: currentpagenum }; let i = index">
                    <td>{{readings.time}}</td>
                    <!-- {{(feedlog && feedlog.survivalRate == null) ? 'NA' : (feedlog && feedlog.survivalRate)}} -->
                    <td>{{readings.pH == null ? 'NA': readings.pH}}</td>
                    <td>{{readings.salinity == null ? 'NA' : readings.salinity}}</td>
                    <td>{{readings.do2 == null ? 'NA' : readings.do2}}</td>
                    <td>{{readings.turbidity == null ? 'NA' : readings.turbidity}}</td>
                    <td>{{readings.conductivity == null ? 'NA' : readings.conductivity}}</td>
                    <td>{{readings.tds == null ? 'NA' : readings.tds}}</td>
                    <td>{{readings.temperature == null ? 'NA' : readings.temperature}}</td>
                    <td>{{readings.sg == null ? 'NA' : readings.sg}}</td>
                    <td>{{readings.nitrite == -1 ? 'NA' : readings.nitrite}}</td>
                    <td>{{readings.calcium == -1 ? 'NA' : readings.calcium}}</td>
                    <td>{{readings.magnesium == -1 ? 'NA' : readings.magnesium}}</td>
                    <td>{{readings.alkalinity == -1 ? 'NA' : readings.alkalinity}}</td>
                    <td>{{readings.hardness == -1 ? 'NA' : readings.hardness}}</td>
                    <td>{{readings.carbonate == -1 ? 'NA' : readings.carbonate}}</td>
                    <td>{{readings.bicarbonate == -1 ? 'NA' : readings.bicarbonate}}</td>
                    <td>{{readings.tan == -1 ? 'NA' : readings.tan}}</td>
                    <td>{{readings.uam == -1 ? 'NA' : readings.uam}}</td>
                    <td>{{readings.ta == -1 ? 'NA' : readings.ta}}</td>
                    <td>{{(readings.comment == "" || readings.comment == null) ? 'NA' : readings.comment}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            </div>
          </div>

        </div>
      </div>
      <!--water modal popup end-->
      <!--sampling modal-->
      <div class="modal fade" id="samplingmyModal" role="dialog" *ngIf="moreSamplings && moreSamplings.length>0">
        <div class="modal-dialog modal-lg">

          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">{{pondName}}</h4>
            </div>
            <div class="modal-body">
              <div class="panel-body table-responsive">
                <table class="table table-striped table-bordered table-hover">
                  <thead>
                  <tr>
                    <td>Date</td>
                    <td>ABW</td>
                    <td>ADG</td>
                    <td>Weight Gained</td>
                    <td>Weight Gained(%)</td>
                    <td>Count</td>
                    <td>DOC</td>
                    <td>Image Count</td>
                    <td>Survival Rate</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    *ngFor="let sampling of moreSamplings |  paginate: { itemsPerPage: noofitemsPerPage, currentPage: currentpagenum }; let i = index">
                    <td>{{sampling.date | date:"dd-MMM-yyyy"}}</td>
                    <td>{{sampling.abw}}</td>
                    <td>{{sampling.adg}}</td>
                    <td>{{sampling.weight_gained}}</td>
                    <td>{{sampling.weight_gained_percentage}}</td>
                    <td>{{sampling.count}}</td>
                    <td>{{sampling.doc}}</td>
                    <td>{{sampling.imagecount}}</td>
                    <td>{{sampling.survival_rate == null ? 'NA' : sampling.survival_rate}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            </div>
          </div>

        </div>
      </div>
      <!--sampling modal end-->
      <!--feed modal-->
      <div class="modal fade" id="feedmyModal" role="dialog" *ngIf="moreFeedlogs && moreFeedlogs.length>0">
        <div class="modal-dialog modal-lg">

          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">{{pondName}}</h4>
            </div>
            <div class="modal-body">
              <div class="panel-body table-responsive">
                <table class="table table-striped table-bordered table-hover">
                  <thead>
                  <tr>
                    <td>Last Feed Given Date</td>
                    <td>Feed Given (Kgs)</td>
                    <td>Feed Required (Kgs)</td>
                    <td>Meal Consumed (Kgs)</td>
                    <td>Cumulative Feed (Kgs)</td>
                    <td>survival Rate (Kgs)</td>
                    <td>Present Biomass (Kgs)</td>
                    <td>DOC</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    *ngFor="let feed of moreFeedlogs |  paginate: { itemsPerPage: noofitemsPerPage, currentPage: currentpagenum }; let i = index">
                    <td>{{feed.last_feed_given_date | date:"dd-MMM-yyyy"}}</td>
                    <td>{{feed.feed_given / 1000 | currencyFormat}}</td>
                    <td>{{feed.feed_required / 1000 | currencyFormat}}</td>
                    <td>{{feed.feed_consumed / 1000 | currencyFormat}}</td>
                    <td>{{feed.cumulative_feed / 1000 | currencyFormat}}</td>
                    <td>{{feed.survival_rate / 1000 | currencyFormat}}</td>
                    <td>{{feed.present_biomass / 1000 | currencyFormat}}</td>
                    <td>{{feed.doc}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            </div>
          </div>

        </div>
      </div>
      <!--feed modal end-->
      <!--feed modal-->
      <div class="modal fade" id="pondfileUpload" role="dialog">
        <div class="modal-dialog">

          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" (click)="clear()" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">{{pondName}}</h4>
            </div>
            <div class="modal-body">
              <form (ngSubmit)="uploadImage()">
                <div class="row top-field">
                  <div class="col-xs-12 col-md-6 col-sm-6">
                    <div class="form-group">
                      <label class="col-md-2 control-label">File </label>
                      <input type="file" multiple name="file" id="upload"
                             [(ngModel)]="data" autocomplete="off" (change)="fileupload('upload', false)"
                             class="form-control select">
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-3 col-sm-3">
                    <div id="barndingimagesattachmetns" *ngIf="selectedbase64file">
                      <img src="{{selectedbase64file}}" width="50" height="50"><span (click)="remove()"><i
                      class="fa fa-times imagedeleteclosebtn" aria-hidden="true"></i></span>
                    </div>
                  </div>
                </div>
                <div class="row top-field">
                  <div class="col-xs-12 col-md-12 col-sm-12">
                    <div class="form-group">
                      <label class="col-md-2 control-label">Description </label>
                      <textarea type="text" name="desc" class="form-control" rows="3"
                                [(ngModel)]="description" autocomplete="off" placeholder=""></textarea>
                    </div>
                  </div>
                </div>

                <div class="text-right" style="margin-bottom: 20px; clear: right">
                  <input type="submit" class="btn btn-success" value="Submit"/>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" (click)="clear()" class="btn btn-default" data-dismiss="modal">Close</button>
            </div>
          </div>

        </div>
      </div>
      <!--feed modal end-->
      <!--bottom tabs-->
      <div class="navbar">
        <div class="col-md-1"></div>
        <div class="col-md-2"><a class="disbledCls"><img src="../../../assets/image/smeimages/Home.png" height="36"
                                                         width="50"/></a></div>
        <div class="col-md-2"><a class="disbledCls"><img src="../../../assets/image/smeimages/photo-camera.png"
                                                         height="36"
                                                         width="42"/></a></div>
        <div class="col-md-2"><a data-toggle="modal" data-target="#pondfileUpload"><img
          src="../../../assets/image/smeimages/add-Button.png" height="37"
          width="37"/></a></div>
        <div class="col-md-2"><a class="disbledCls"><img src="../../../assets/image/smeimages/rupee-indian.png"
                                                         height="36"
                                                         width="23"/></a></div>
        <div class="col-md-2"><a class="disbledCls"><img src="../../../assets/image/smeimages/Stock.png" height="38"
                                                         width="35"/></a></div>
        <div class="col-md-1"></div>
      </div>
    </div>
    <div class="col-md-5">
      <div class="row chatheading">
        <div class="col-md-12">
          <div class="col-md-10">
            <span>{{selectedBusinessName}}</span> <span> #-{{selectedLocationName}}</span>
          </div>
          <div class="col-md-1" (click)="getChatMedia()" data-toggle="modal" data-target="#chatModal">
            <img src="../../../assets/image/smeimages/gallery.png" height="32"
                 width="30"/>
          </div>
          <div class="col-md-1">
            <a class="mb-control logout-zindex" data-box="#mb-signout" (click)="logout()"><span
              class="fa fa-sign-out logout"></span></a></div>
        </div>
      </div>
      <div class="row chart history" *ngIf="messagesList && messagesList.length == 0">
        <div class="row">
          <img src="../../../assets/image/smeimages/NoConversation-01.png" height="500" width="500"/>
        </div>
        <div class="row" style="text-align: center;">
          <div class="col-lg-12">
            <button class="btn btn-info update btn_color" type="submit">Start Conversation
            </button>
          </div>
        </div>
      </div>
      <!-- <div class="row userchat" #scrollBottom id="div1" *ngIf="messagesList && messagesList.length>0" (scroll)="onScroll($event)"> -->
      <div id="chatWindow" class="row userchat" #scrollBottom *ngIf="messagesList && messagesList.length>0"
           (scroll)="onScroll($event)">
        <div class="chathisstory" *ngFor="let message of messagesList">
          <div class="row">
            <div class="col-xs-12" [ngClass]="loginPersonID == message.senderID ? 'rightside' : ''">
              <div class="content-data">
                <!--<p>-->
                <label class="chatcontent"
                       [ngClass]="loginPersonID == message.senderID ? 'rightside-message' : 'leftside-message'"
                       *ngIf="message['message']['MIMEType']=='.txt'">{{message['message']['data']}}</label>
                <!--</p>-->
                <video controls *ngIf="message['message']['MIMEType']=='.mp4'" width="300" height="300">
                  <source [src]="transform(message['message']['data'])" type="video/mp4">
                </video>
                <img
                  *ngIf="message['message']['MIMEType']==['.png'] || message['message']['MIMEType']=='.jpeg'||message['message']['MIMEType']=='.jpg'"
                  [src]="transform(message['message']['data'])" width="300" height="300">
                <p style="margin-top: 11px;">{{message['date']}}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="footer">
          <!-- <form> -->
          <div>
            <div class="col-xs-10">
              <div class="form-group">
                <input class="col-xs-12 form-control" type="text" name="entertext" [(ngModel)]="farmTeleHealth.enterdata"
                       autocomplete="off" id="text"
                       placeholder="Type a message" (keydown)="keyDownFunction($event)">
              </div>
            </div>
            <div class="col-xs-1">

              <input type="file" style="display:none;" id="chatAttachment"
                     (change)="fileupload('chatAttachment', true)"/>
              <input type="image" src="../../../assets/image/smeimages/Attachment.png" height="23"
                     width="23" alt="click to upload" class="attachmentstyle" style="margin-top: 8px;"
                     onclick="document.getElementById('chatAttachment').click();"/>
            </div>
            <div class="col-xs-1" id="submit" (click)="onSendMessage()">
              <img src="../../../assets/image/smeimages/Send.png" height="45" width="45" style="margin-top: 1px;"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--chat media modal popup-->
    <div class="modal fade" id="chatModal" role="dialog">
      <div class="modal-dialog modal-lg">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <!--<h4 class="modal-title">{{pondName}}</h4>-->
          </div>
          <div class="modal-body" style="overflow-y: scroll; height: 600px">
            <div class="row" *ngFor="let media of chatMediaData">
              <div class="row">
                <p>{{media['_id']}}</p>
              </div>
              <div class="row col-xs-3" *ngFor="let image of media['attachments']">
                <img [src]="transform(image['message']['data'])" width="200" height="200"
                     *ngIf="image['message']['MIMEType']==['.png'] || image['message']['MIMEType']=='.jpeg'||image['message']['MIMEType']=='.jpg'">
                <video controls *ngIf="image['message']['MIMEType']=='.mp4'" width="200" height="200">
                  <source [src]="transform(image['message']['data'])" type="video/mp4">
                </video>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          </div>
        </div>

      </div>
    </div>
    <!--chat media modal popup end-->
  </div>
</div>
